import { createContext, useState } from 'react';
import AppButton from 'components/Inputs/Buttons';
// import { MdOutlinePreview } from 'react-icons/md';
import EditorPreview from 'components/molecules/TexPlacer/EditorPreview';
import { IoIosEye } from 'react-icons/io';

const EditorPreviewContext = createContext();
const { Provider } = EditorPreviewContext;

function EditorPreviewProvider({ children }) {
  const [previewModal, togglePreviewModal] = useState({ open: false, block: null });

  function PreviewBtn({ label = 'Preview', labelIcon = null, block }) {
    return (
      <>
        {/* <AppButton
          variantClass="btn btn-md btn-secondary mx-4"
          onClick={() => togglePreviewModal({ open: true, block })}
        >
          {labelIcon ? labelIcon : <IoIosEye />}
          {label}
        </AppButton> */}
      </>
    );
  }

  return (
    <Provider
      value={{
        PreviewBtn,
      }}
    >
      {previewModal.open && (
        <EditorPreview
          editorData={previewModal.block}
          open={previewModal.open}
          closeModal={() => {
            togglePreviewModal({ open: false, block: null });
          }}
        />
      )}
      {children}
    </Provider>
  );
}

export { EditorPreviewProvider, EditorPreviewContext };
